import axios from "axios";
import Cookies from "js-cookie";
import intlTelInput from 'intl-tel-input';


$(function(e){

  /**
   * add country flags and country codes on input for mobile
   * @type {Element}
   */
  const input = document.querySelector(".mobile");
  intlTelInput(input, {
    initialCountry: "in",
    separateDialCode: true,
    nationalMode: true
  });

  /**
   * storing JWT access token in axios config file if token exists in cookie
   */
  window.axiosHeaders = {};
  const JWT_ACCESS_TOKEN = Cookies.get('jwt_parent_access_token') || '';

  if (JWT_ACCESS_TOKEN.length) {
    axiosHeaders.headers = {Authorization: `Bearer ${JWT_ACCESS_TOKEN}`};
  }


  /**
   * Logout action
   */
  $('.logoutBtn').on('click', async function (e) {
    e.preventDefault();
    try{
      await axios.post(HOST + API_PATH +'/parent/logout', {}, axiosHeaders);
      Cookies.remove('jwt_parent_access_token');
      localStorage.clear();
      window.location.reload();
    }catch(exception){
      console.log(exception, 'exception');
    }

  });

  /**
   * Check/Register user and send otp
   */
  $('#checkParentExist').on('submit', function(e){
    e.preventDefault();
    const FORM = $(this);
    const FORM_DATA = new FormData(this);
    const SUBMIT_BUTTON = FORM.find('[type=submit]');
    const COUNTRY_CODE = FORM.find('.iti__selected-dial-code').text();

    if (FORM_DATA.get('mobile').length !== 10) {
      showResponseMessageBySelector(SUBMIT_BUTTON, 'incorrect mobile number', 'danger', 'before');
      return false;
    }

    SUBMIT_BUTTON.prev('.response-msg').remove();
    FORM_DATA.append('role', 'PARENT');
    FORM_DATA.append('country_code', COUNTRY_CODE.substr(1, COUNTRY_CODE.length));
    SUBMIT_BUTTON.html(`<i class="fas fa-circle-notch fa-spin"></i> Get OTP`);
    SUBMIT_BUTTON.prop('disabled', true);
    axios.post(HOST + API_PATH+'/parent/login', FORM_DATA).then((res) => {
      SUBMIT_BUTTON.html('Get OTP');
      SUBMIT_BUTTON.prop('disabled', false);
      console.log(res.data.parent_name, 'res');
      $('#parentName').val(res.data.parent_name);
      $('.parentMobileNumber').val(FORM_DATA.get('mobile')).text(FORM_DATA.get('mobile'));
      $('.parentMobileCountryCode').text(COUNTRY_CODE);
      $('#loginStep2').collapse('show');

      // start otp counter
      resendOTPTimer($('#otpTimerContainer'));

      // resendOTPTimer(FORM);
    }).catch((error) => {
      SUBMIT_BUTTON.html('Get OTP');
      SUBMIT_BUTTON.prop('disabled', false);
      showResponseMessageBySelector(SUBMIT_BUTTON, error.response.data.msg, 'danger', 'before');
    });

  });

  /**
   * login user with otp
   */
  $('#parentLoginWithOtp').on('submit', function(e){
    e.preventDefault();
    const FORM = $(this);
    const FORM_DATA = new FormData(this);
    const SUBMIT_BUTTON = FORM.find('[type=submit]');

    SUBMIT_BUTTON.prev('.response-msg').remove();
    FORM_DATA.append('role', 'PARENT');
    axios.post(HOST + API_PATH+'/parent/login-with-otp', FORM_DATA).then((response) => {
      // console.log(response);

      Cookies.set('jwt_parent_access_token', response.data.access_token, {expires: 7, path: '/'});
      localStorage.setItem('parent_info', JSON.stringify(response.data.user_info));
      $('#webLoginModal').modal('hide');
      $('#webLoginBtn').removeClass('d-inline-block').addClass('d-none');
      $('#webLogoutBtn').removeClass('d-none').addClass('d-inline-block');
      $('#wishlist-login').removeClass('d-inline-block').addClass('d-none');
      $('#wishlist').removeClass('d-none').addClass('d-inline-block');
      $('#shortlist-btn-login').removeClass('d-inline-block').addClass('d-none');
      $('#shortlist-btn-a').removeClass('d-none').addClass('d-inline-block');

      if($('.user-not-logged-in').length){
        $('.user-not-logged-in > *').css('filter', 'blur(0)');
      }
      if($('.web-login-message1').length){
        $('.web-login-message1').remove();
      }

      /*const COURSE_DEMO_REQUESTING = $('.courseEnrollNow.demoRequesting');
      if(COURSE_DEMO_REQUESTING.length){
        COURSE_DEMO_REQUESTING.next('.link-overlay').remove();
        COURSE_DEMO_REQUESTING.removeClass('demoRequesting');
      }*/

      // window.location.reload();

    }).catch((error) => {
      console.log(error.response.data.msg, 'test');
      showResponseMessageBySelector(SUBMIT_BUTTON, error.response.data.msg, 'danger', 'before');
    });

  });

  /**
   * Resend otp button action
   */
  $('body').on('click', '.resendOTPBtn', function (e) {
    e.preventDefault();
    let resendOtpSelector = $(this);
    let form = document.getElementById($(this).data('formid'));
    let FORM_DATA = new FormData(form);
    const SUBMIT_BUTTON = $(`#${$(this).data('formid')}`).find('[type=submit]');

    resendOtpSelector.prop('disabled', true);
    SUBMIT_BUTTON.prev('.response-msg').remove();

    FORM_DATA.append('role', 'PARENT');
    FORM_DATA.delete('otp'); // remove otp field from request

    resendOtpSelector.addClass('sr-only');

    axios.post(HOST + API_PATH + '/parent/resend-otp', FORM_DATA).then((response) => {
      resendOtpSelector.prop('disabled', false);
      showResponseMessageBySelector(SUBMIT_BUTTON, response.data.msg, 'success', 'before');
      // start otp counter
      resendOTPTimer($('#otpTimerContainer'));
    }).catch((error) => {
      resendOtpSelector.removeClass('sr-only');
      resendOtpSelector.prop('disabled', false);
      showResponseMessageBySelector(SUBMIT_BUTTON, error.response.data.msg, 'danger', 'before');
    });

  });
});

/**
 * Show resend otp timer
 * @param otpTimerContainer container selector
 */
function resendOTPTimer(otpTimerContainer) {

  console.log('otpTimerContainer', otpTimerContainer);
  let send_otp_duration = 4;
  let timerClass = otpTimerContainer.find('.otpTimer');
  timerClass.removeClass('sr-only');

  let timer = setInterval(function () {
    console.log('timer');
    timerClass.html(`Resend OTP 00:${(send_otp_duration < 10) ? '0' + send_otp_duration : send_otp_duration}`);
    if (send_otp_duration === 0) {
      otpTimerContainer.find('.resendOTPBtn').removeClass('sr-only');
      otpTimerContainer.find('.otpTimer').addClass('sr-only');
      clearInterval(timer);
    }
    send_otp_duration--;
  }, 1000)
}

/**
 *  This will show response message
 * @param selector
 * @param msg string
 * @param type string bootstrap class (success, danger, warning etc.)
 * @param position string (before, after)
 */
function showResponseMessageBySelector(selector, msg, type, position)
{
  const MSG = `<p class="text-center text-${type} font-weight-bold response-msg">${msg}</p>`;
  if(position === 'before'){
    selector.before(MSG);
  }else{
    selector.after(MSG)
  }
}
